(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[784],{

/***/ 13194:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agencies/[slug]",
      function () {
        return __webpack_require__(92768);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ AgencyLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64043);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55351);
/* harmony import */ var _old_marketing_components_globals_footers_DefaultFooter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64774);
/* harmony import */ var _old_marketing_components_GlobalStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14399);






var AgencyLayout = function(param) {
    var children = param.children, layout = param.layout;
    var ref, ref1, ref2;
    var ref3, ref4;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__/* .AnalyticsProvider */ .ng, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__/* .AnalyticsPageRouting */ .eQ, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    href: "/fonts/brice/brice.css",
                    rel: "stylesheet"
                }, "gelica-font")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_old_marketing_components_GlobalStyle__WEBPACK_IMPORTED_MODULE_5__/* .GlobalStyle */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                description: "Take your brand to new heights. Find the right agency for you.",
                openGraph: {
                    title: (ref3 = layout === null || layout === void 0 ? void 0 : (ref = layout.seo) === null || ref === void 0 ? void 0 : ref.title) !== null && ref3 !== void 0 ? ref3 : "The Agency Directory",
                    images: [
                        {
                            url: "/assets/marketing/agency-share-image.png",
                            width: 600,
                            height: 315
                        }, 
                    ]
                },
                title: (ref4 = layout === null || layout === void 0 ? void 0 : (ref1 = layout.seo) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref4 !== void 0 ? ref4 : "The Agency Directory",
                titleTemplate: (layout === null || layout === void 0 ? void 0 : (ref2 = layout.seo) === null || ref2 === void 0 ? void 0 : ref2.title) ? "%s | The Agency Directory" : "%s"
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_old_marketing_components_globals_footers_DefaultFooter__WEBPACK_IMPORTED_MODULE_4__/* .DefaultFooter */ .q, {})
        ]
    });
};


/***/ }),

/***/ 88332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ AgencyContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_zephyr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55164);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var AgencyContainer = function(_param) /*#__PURE__*/ {
    var tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "tx"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, _objectSpread({
        tx: _objectSpread({
            width: "100%",
            maxWidth: 1224,
            px: 32,
            mx: "auto"
        }, tx)
    }, restOfProps));
};



/***/ }),

/***/ 98286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ AgencyHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_marketing_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89170);
/* harmony import */ var _air_zephyr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55164);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _old_marketing_components_agency_AgencyContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88332);
/* harmony import */ var _old_marketing_constants_Routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46955);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var AgencyHeader = function(param) {
    var tx = param.tx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "header",
        tx: _objectSpread({
            display: "flex",
            alignItems: "center",
            height: 72
        }, tx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_old_marketing_components_agency_AgencyContainer__WEBPACK_IMPORTED_MODULE_4__/* .AgencyContainer */ .Q, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: _old_marketing_constants_Routes__WEBPACK_IMPORTED_MODULE_5__/* .Routes.root */ .Z5.root,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                    as: "a",
                    tx: {
                        display: "block",
                        height: [
                            24,
                            28
                        ],
                        mr: 24,
                        color: "inherit"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_marketing_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Logo */ .TR, {
                        css: {
                            fill: "currentColor",
                            height: "100%"
                        }
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 25547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ AgencySizes; }
/* harmony export */ });
var AgencySizes = [
    {
        name: "2-10",
        value: "size_2_10"
    },
    {
        name: "11-50",
        value: "size_11_50"
    },
    {
        name: "51-200",
        value: "size_51_200"
    },
    {
        name: "201-500",
        value: "size_201_500"
    },
    {
        name: "501-1000",
        value: "size_501_1000"
    },
    {
        name: "1001-5000",
        value: "size_1001_5000"
    },
    {
        name: "5001-10000",
        value: "size_5001_10000"
    },
    {
        name: "10001+",
        value: "size_10001"
    }, 
];


/***/ }),

/***/ 13968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ AgencyTypes; }
/* harmony export */ });
var AgencyTypes = [
    {
        name: "Advertising",
        value: "advertising"
    },
    {
        name: "Architecture",
        value: "architecture"
    },
    {
        name: "Branding",
        value: "branding"
    },
    {
        name: "Communications",
        value: "communications"
    },
    {
        name: "Computer Software",
        value: "computer_software"
    },
    {
        name: "Consulting",
        value: "consulting"
    },
    {
        name: "Consumer Electronics",
        value: "consumer_electronics"
    },
    {
        name: "Consumer Goods",
        value: "consumer_goods"
    },
    {
        name: "Content",
        value: "content"
    },
    {
        name: "Content Marketing",
        value: "content_marketing"
    },
    {
        name: "Creative",
        value: "creative"
    },
    {
        name: "Design",
        value: "design"
    },
    {
        name: "Digital Advertising",
        value: "digital_advertising"
    },
    {
        name: "Digital Marketing",
        value: "digital_marketing"
    },
    {
        name: "Digital Product",
        value: "digital_product"
    },
    {
        name: "Digital Production",
        value: "digital_production"
    },
    {
        name: "Digital Strategies",
        value: "digital_strategies"
    },
    {
        name: "Digital Strategy",
        value: "digital_strategy"
    },
    {
        name: "Education Management",
        value: "education_management"
    },
    {
        name: "Entertainment",
        value: "entertainment"
    },
    {
        name: "Furniture",
        value: "furniture"
    },
    {
        name: "Graphic Design",
        value: "graphic_design"
    },
    {
        name: "Growth",
        value: "growth"
    },
    {
        name: "Growth Marketing",
        value: "growth_marketing"
    },
    {
        name: "Growth Strategy",
        value: "growth_strategy"
    },
    {
        name: "Hospitality",
        value: "hospitality"
    },
    {
        name: "Image Editing",
        value: "image_editing"
    },
    {
        name: "Influencer Marketing",
        value: "influencer_marketing"
    },
    {
        name: "Information Technology & Services",
        value: "information_technology_services"
    },
    {
        name: "Insurance",
        value: "insurance"
    },
    {
        name: "Internet",
        value: "internet"
    },
    {
        name: "Leisure",
        value: "leisure"
    },
    {
        name: "Management Consulting",
        value: "management_consulting"
    },
    {
        name: "Marketing",
        value: "marketing"
    },
    {
        name: "Media Production",
        value: "media_production"
    },
    {
        name: "Non-profit Organization Management",
        value: "non_profit_organization_management"
    },
    {
        name: "PR",
        value: "pr"
    },
    {
        name: "Photography",
        value: "photography"
    },
    {
        name: "Production",
        value: "production"
    },
    {
        name: "Public Relations & Communications",
        value: "public_relations_communications"
    },
    {
        name: "Publishing",
        value: "publishing"
    },
    {
        name: "Retail",
        value: "retail"
    },
    {
        name: "SEO",
        value: "seo"
    },
    {
        name: "Social Media Marketing",
        value: "social_media_marketing"
    },
    {
        name: "Staffing & Recruiting",
        value: "staffing_recruiting"
    },
    {
        name: "Strategy",
        value: "strategy"
    },
    {
        name: "Travel",
        value: "travel"
    },
    {
        name: "Web Design",
        value: "web_design"
    }, 
];


/***/ }),

/***/ 87234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ formatAgencyTypes; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _old_marketing_constants_AgencyTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13968);


var formatAgencyTypes = function(types) {
    if (!types.length) return;
    var formattedTypes = types.map(function(type) {
        var ref;
        return (ref = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.find)(_old_marketing_constants_AgencyTypes__WEBPACK_IMPORTED_MODULE_1__/* .AgencyTypes */ .X, [
            "value",
            type
        ])) === null || ref === void 0 ? void 0 : ref.name;
    });
    if (formattedTypes.length > 1) {
        return [
            formattedTypes.slice(0, -1).join(", "),
            formattedTypes.slice(-1)[0]
        ].join(" & ");
    }
    return formattedTypes.join(" & ");
};


/***/ }),

/***/ 92768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AgenciesBySlugPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@air/icons/dist/icons.esm.js
var icons_esm = __webpack_require__(74398);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/layouts/AgencyLayout.tsx
var AgencyLayout = __webpack_require__(24296);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/old-marketing/components/agency/AgencyContainer.tsx
var AgencyContainer = __webpack_require__(88332);
// EXTERNAL MODULE: ./src/old-marketing/constants/Routes.ts
var Routes = __webpack_require__(46955);
;// CONCATENATED MODULE: ./src/old-marketing/components/agency/AgencyCallToActionSection.tsx






var AgencyCallToActionSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        as: "section",
        tx: {
            zIndex: 1,
            position: "relative",
            backgroundColor: "macaw600",
            py: [
                96,
                140
            ]
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    zIndex: -1,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: 829,
                    src: "/assets/marketing/agency-form-background.svg",
                    width: 1440
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyContainer/* AgencyContainer */.Q, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    tx: {
                        maxWidth: 600,
                        mx: "auto",
                        textAlign: [
                            "left",
                            "center"
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                            as: "h2",
                            tx: {
                                mb: 16,
                                color: "pigeon025",
                                fontFamily: "Brice-SemiBoldSemiExpanded",
                                fontSize: [
                                    28,
                                    36
                                ],
                                letterSpacing: "0.03em",
                                lineHeight: 1.15
                            },
                            children: "Made by the team at Air"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                            as: "p",
                            tx: {
                                mb: 40,
                                color: "white",
                                textAlign: [
                                    "left",
                                    "center"
                                ]
                            },
                            variant: [
                                "text-ui-18",
                                "text-ui-20"
                            ],
                            children: "Air is where creative process happens. Centralize your team's content in a workspace that's organized, searchable, versioned, and easy to share. Your first 5GB are on us!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: Routes/* AuthRoutes.signUp */.t5.signUp,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                                as: "a",
                                size: "large",
                                children: "Sign up for free"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/old-marketing/components/agency/AgencyHeader.tsx
var AgencyHeader = __webpack_require__(98286);
// EXTERNAL MODULE: ../../node_modules/@graphcms/rich-text-react-renderer/dist/rich-text-react-renderer.esm.js + 1 modules
var rich_text_react_renderer_esm = __webpack_require__(11387);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ./src/old-marketing/constants/AgencySizes.ts
var AgencySizes = __webpack_require__(25547);
// EXTERNAL MODULE: ./src/old-marketing/utils/formatAgencyTypes.ts
var formatAgencyTypes = __webpack_require__(87234);
;// CONCATENATED MODULE: ./src/old-marketing/components/agency/AgencyInformation.tsx








var AgencyInformation = function(param) {
    var clientLogos = param.clientLogos, companySize = param.companySize, description = param.description, facebookUrl = param.facebookUrl, instagramUrl = param.instagramUrl, linkedInUrl = param.linkedInUrl, location1 = param.location, logo1 = param.logo, name = param.name, twitterUrl = param.twitterUrl, types = param.types, websiteUrl = param.websiteUrl;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        as: "article",
        tx: {
            color: "pigeon700"
        },
        children: [
            logo1 && logo1.height && logo1.width && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "relative",
                    borderRadius: 8,
                    pb: "48%",
                    mb: 40,
                    overflow: "hidden",
                    img: {
                        objectFit: "contain"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    src: logo1.url
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                as: "h1",
                tx: {
                    mb: 24,
                    color: "inherit"
                },
                variant: "text-ui-32",
                children: name
            }),
            (facebookUrl || instagramUrl || linkedInUrl || twitterUrl || websiteUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    display: "flex",
                    mb: 32
                },
                children: [
                    websiteUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                        as: "a",
                        href: websiteUrl,
                        icon: icons_esm/* Web */.phX,
                        rel: "noopener noreferrer",
                        size: "medium",
                        target: "_blank",
                        tx: {
                            mr: 8
                        },
                        variant: "button-ghost-grey",
                        children: "".concat(name, " website")
                    }),
                    facebookUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                        as: "a",
                        href: facebookUrl,
                        icon: icons_esm/* Facebook */.s1S,
                        rel: "noopener noreferrer",
                        size: "medium",
                        target: "_blank",
                        tx: {
                            mr: 8
                        },
                        variant: "button-ghost-grey",
                        children: "Facebook"
                    }),
                    twitterUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                        as: "a",
                        href: twitterUrl,
                        icon: icons_esm/* Twitter */.tLe,
                        rel: "noopener noreferrer",
                        size: "medium",
                        target: "_blank",
                        tx: {
                            mr: 8
                        },
                        variant: "button-ghost-grey",
                        children: "Twitter"
                    }),
                    linkedInUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                        as: "a",
                        href: linkedInUrl,
                        icon: icons_esm/* LinkedIn */.yhk,
                        rel: "noopener noreferrer",
                        size: "medium",
                        target: "_blank",
                        tx: {
                            mr: 8
                        },
                        variant: "button-ghost-grey",
                        children: "LinkedIn"
                    }),
                    instagramUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                        as: "a",
                        href: instagramUrl,
                        icon: icons_esm/* Instagram */.mre,
                        rel: "noopener noreferrer",
                        size: "medium",
                        target: "_blank",
                        tx: {
                            mr: 8
                        },
                        variant: "button-ghost-grey",
                        children: "Instagram"
                    })
                ]
            }),
            types && /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Text */.xv, {
                as: "p",
                tx: {
                    mb: 8,
                    color: "inherit"
                },
                variant: "text-ui-18",
                children: [
                    "Type: ",
                    (0,formatAgencyTypes/* formatAgencyTypes */.R)(types)
                ]
            }),
            companySize && /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Text */.xv, {
                as: "p",
                tx: {
                    mb: 8,
                    color: "inherit"
                },
                variant: "text-ui-18",
                children: [
                    "Size: ",
                    (ref = (0,lodash.find)(AgencySizes/* AgencySizes */.W, [
                        "value",
                        companySize
                    ])) === null || ref === void 0 ? void 0 : ref.name
                ]
            }),
            location1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Text */.xv, {
                as: "p",
                tx: {
                    mb: 24,
                    color: "inherit"
                },
                variant: "text-ui-18",
                children: [
                    "Location: ",
                    location1.map(function(location) {
                        return location.replace(",", ", ");
                    }).join(", ")
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                tx: {
                    mb: 40
                },
                variant: "text-ui-18",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text_react_renderer_esm/* RichText */.H, {
                    content: description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                as: "h2",
                tx: {
                    mb: 32,
                    color: "inherit",
                    fontWeight: "semibold"
                },
                variant: "text-ui-24",
                children: "Clients include"
            }),
            clientLogos && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    display: "grid",
                    gridGap: 48,
                    gridTemplateColumns: "repeat(3, 1fr)",
                    mb: 40
                },
                children: clientLogos.map(function(logo) {
                    if (!(logo && logo.height && logo.width)) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "relative",
                            height: 72,
                            img: {
                                objectFit: "contain"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            src: logo.url
                        })
                    }, logo.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/upsells/AgencyUpsell.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var AgencyUpsell = function(param) {
    var tx = param.tx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        tx: _objectSpread({
            zIndex: 1,
            position: "relative",
            backgroundColor: "peacock400",
            px: 24,
            py: 32,
            textAlign: "center",
            borderRadius: 4
        }, tx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    zIndex: -1,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "Swirls",
                    height: 441,
                    src: "/assets/marketing/agency-upsell-swirls.svg",
                    width: 694
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                tx: {
                    maxWidth: 382,
                    mx: "auto",
                    mb: 24,
                    color: "jay700"
                },
                variant: "text-heading-32",
                children: "Manage client projects with ease"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: Routes/* AuthRoutes.signUp */.t5.signUp,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                    as: "a",
                    variant: "button-filled-blue",
                    children: "Try Air for free"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/agencies/[slug].tsx












var __N_SSG = true;
function AgenciesBySlugPage(param) {
    var agency = param.agency;
    var ref;
    var router = (0,next_router.useRouter)();
    if (!agency || router.isFallback) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyHeader/* AgencyHeader */.q, {
                tx: {
                    borderBottom: "1px solid",
                    borderBottomColor: "pigeon100",
                    color: "jay600"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyContainer/* AgencyContainer */.Q, {
                tx: {
                    my: 24
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: Routes/* Routes.agencies */.Z5.agencies,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Text */.xv, {
                        as: "a",
                        tx: {
                            display: "flex",
                            alignItems: "center",
                            color: "pigeon700",
                            fontWeight: "medium",
                            textDecoration: "none"
                        },
                        variant: "text-ui-18",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                                icon: icons_esm/* ChevronLeft */.s$$,
                                size: "medium",
                                tx: {
                                    width: 32,
                                    height: 32,
                                    mr: 4
                                },
                                variant: "button-ghost-grey",
                                children: "Go back"
                            }),
                            "Back to database"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    maxWidth: 774,
                    mx: "auto",
                    mt: 64,
                    px: 20,
                    mb: 140
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                        tx: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                                as: "h1",
                                tx: {
                                    fontFamily: "Brice",
                                    fontWeight: "semibold",
                                    letterSpacing: "unset",
                                    color: "macaw500",
                                    mb: 16
                                },
                                variant: "text-heading-56",
                                children: "The agency directory"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                                as: "p",
                                tx: {
                                    mb: 56
                                },
                                variant: "text-ui-20",
                                children: "Browse our library of agencies from across the map, offering services in marketing, design, creative production, content, PR, and more!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyInformation, {
                        clientLogos: agency.clientLogos,
                        companySize: agency.companySize,
                        description: agency.description.raw,
                        facebookUrl: agency.facebookUrl,
                        instagramUrl: agency.instagramUrl,
                        linkedInUrl: agency.linkedInUrl,
                        location: agency.location,
                        logo: (ref = agency.logos) === null || ref === void 0 ? void 0 : ref[0],
                        name: agency.name,
                        twitterUrl: agency.twitterUrl,
                        types: agency.types,
                        websiteUrl: agency.websiteUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyUpsell, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyCallToActionSection, {})
        ]
    });
};
AgenciesBySlugPage.layout = AgencyLayout/* AgencyLayout */.c;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [512,387,497,478,774,888,179], function() { return __webpack_exec__(13194); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);